import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';


interface PillAnchorProps {
  text: string;
  url: string;
}

const PillAnchor: React.FC<PillAnchorProps> = ({ text, url }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentPath = window.location.pathname;
      setIsActive(currentPath === url);
    }
  }, [url]);

  return (
    <div className="flex-1 h-full flex justify-center items-center relative">
      <div
        className={`absolute lg:-top-18px -top-14px w-full lg:max-w-learning-center-overline
          max-w-learning-center-overline-mobile h-1 bg-ii-blue ${isActive ? 'flex' : 'hidden'}`}
      />
      <Link to={url} className="lg:text-2xl text-sm font-bold">
        {text}
      </Link>
    </div>
  );
};

export default PillAnchor;